import React, { useState } from 'react';
import { Box, Typography, Button, Grid, Card, CardContent, CardMedia, Divider, Dialog, DialogTitle, TextField, RadioGroup, FormControlLabel, Radio, DialogActions,useMediaQuery } from '@mui/material';

import droneImage5 from '../../assets/image/png/farm.png';
// import logo from '../Image/Drone Planet Logo White.png';
import image from '../../assets/image/png/Untitled-1_0000s_0000_Layer-7.png';
import image1 from '../../assets/image/png/Untitled-1_0000s_0001_Layer-6.png';
import image3 from '../../assets/image/png/Untitled-1_0000s_0003_Drone-Survey.png';
import image4 from '../../assets/image/png/Untitled-1_0004_Layer-1.png';
import image5 from '../../assets/image/png/Untitled-1_0000s_0002_freepik__enhance__31360.png';
import image6 from '../../assets/image/png/Quality Assurance.png';
import image7 from '../../assets/image/png/Flexibility.png';
import image8 from '../../assets/image/png/Expert Network.png';
import imgss from '../../assets/video/7031255_Nature_Aerial_1920x1080.mp4';
import logo from '../../assets/image/png/image (11).png';
import logo1 from '../../assets/image/png/image (10).png';
import logo2 from '../../assets/image/png/image (3).jpg';
import drone from '../../assets/image/png/drone_.png';
import { AccessAlarm, WaterDrop } from '@mui/icons-material';
import { blue, brown, green } from '@mui/material/colors';
import axios from "axios";
import { useTheme } from '@mui/material/styles';
import { toast } from "react-toastify";
const DroneRepair = () => {

  const [openDialog, setOpenDialog] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [formData, setFormData] = useState({
    name: '',
    phoneNumber: '',
    pincode: '',
    address: '',
    radioOption: '',
  });

  const handleDialogOpen = () => {
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
 
    // Basic validation check
    if (!formData.name || !formData.phoneNumber || !formData.pincode || !formData.address || !formData.radioOption) {
      toast.error("All fields are required.");
      handleDialogClose();
      return;
    }
 
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "/addDaasData",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
 
      toast.success("Form Submitted Successfully!");
      setShowAlert(true);
 
      // Reset form fields
      setFormData({
        name: '',
        phoneNumber: '',
        pincode: '',
        address: '',
        radioOption: '',
      });

      handleDialogClose();

    } catch (err) {
      toast.error("Error submitting the form.");
      setShowAlert(false);
    }
 };
  return (
    <div style={{backgroundColor: '#f8f7f0'}}>
      {/* Video Section */}
      <Box sx={{ position: 'relative', width: '100%', height: '80vh', marginTop: '20px' }}>
      <video
  src={imgss} // Replace with your video URL
  style={{
    width: '100%',
    height: '100%',
    objectFit: 'cover',pointerEvents: 'none', // Disable interaction with the video
  }}
  playsInline // Ensures video plays inline on iOS
  muted
  loop
  autoPlay
  controls={false} // Disable default controls
  onError={(e) => console.error("Video failed to load", e)} // Debugging
/>

{/* Black Tint Overlay */}
<Box
  sx={{
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)', // Black tint with opacity (adjust 0.5 for intensity)
  }}
/>


  {/* Overlay Content */}
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      textAlign: 'center',
      color: 'white',
      width: '80%', // Reduced width for better content spacing
    }}
  >
    <Typography variant="h3" sx={{fontWeight: 500,marginBottom: 1,fontSize: '2rem',fontFamily: 'Roboto',textShadow: '2px 2px 5px rgba(0, 0, 0, 0.7)',}}>
      Experience the Future of Drone Services
    </Typography>
    <Typography variant="h4" sx={{ fontWeight: '300', marginTop: 1, fontSize: '1.5rem', fontFamily: 'Roboto',textShadow: '2px 2px 5px rgba(0, 0, 0, 0.7)' }}>
      Hire Expert Professionals Today!
    </Typography>
    <Typography variant="body1" sx={{ marginTop: 2, fontSize: '1.1rem', lineHeight: 1.5, fontFamily: 'Arial',textShadow: '2px 2px 5px rgba(0, 0, 0, 0.7)' }}>
      We offer aerial services and on-demand skilled pilots and technicians for your needs.
    </Typography>

    {/* Book Now Button */}
    <Button
          variant="contained"
          sx={{
            marginTop: 3,
            backgroundColor: green[500],
            color: 'white',
            '&:hover': {
              backgroundColor: green[700],
            },
          }}
          onClick={handleDialogOpen}
        >
          Book Now
        </Button>
  </Box>

  {/* Dialog (Popup Form) */}
  <Dialog
      open={openDialog}
      onClose={handleDialogClose}
      maxWidth="xs"
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: 2,
          padding: isMobile ? 2 : 4,
          maxHeight: '120vh',
          backgroundColor: '#FFFFFF', // White background
          overflowY: 'auto',
        },
      }}
    >
      <DialogTitle
        sx={{
          backgroundColor: '#FFFFFF',
          color: '#388e3c',
          textAlign: 'center',
          fontSize: '1.5rem',
          fontWeight: 600,
        }}
      >
        Book Your Service
      </DialogTitle>

      <Box
        sx={{
          padding: 0,
          backgroundColor: '#FFFFFF',
          borderRadius: 2,
          maxHeight: '95vh',
          overflowY: 'auto',
        }}
      >
        {/* Name */}
        <TextField
          fullWidth
          label="Name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          variant="standard"
          sx={{
            mb: 2,
            '& .MuiInput-underline:before': { borderBottomColor: '#388e3c' }, // Default black underline
            '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: '#4caf50' }, // Green hover effect
            '& .MuiInput-underline:after': { borderBottomColor: '#388e3c' }, // Green focus effect
            '& .MuiInputLabel-root.Mui-focused': { color: '#4caf50' }, // Green label on focus
          }}
        />

        {/* Phone Number */}
        <TextField
          fullWidth
          label="Phone Number"
          name="phoneNumber"
          value={formData.phoneNumber}
          onChange={(e) => {
            if (/^\d{0,10}$/.test(e.target.value)) handleChange(e);
          }}
          variant="standard"
          sx={{
            mb: 2,
            '& .MuiInput-underline:before': { borderBottomColor: '#388e3c' }, // Default black underline
            '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: '#4caf50' }, // Green hover effect
            '& .MuiInput-underline:after': { borderBottomColor: '#388e3c' }, // Green focus effect
            '& .MuiInputLabel-root.Mui-focused': { color: '#4caf50' }, // Green label on focus
          }}
        />

        {/* Pincode */}
        <TextField
          fullWidth
          label="Pincode"
          name="pincode"
          value={formData.pincode}
          onChange={(e) => {
            if (/^\d{0,6}$/.test(e.target.value)) handleChange(e);
          }}
          variant="standard"
          sx={{
            mb: 2,
            '& .MuiInput-underline:before': { borderBottomColor: '#388e3c' }, // Default black underline
            '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: '#4caf50' }, // Green hover effect
            '& .MuiInput-underline:after': { borderBottomColor: '#388e3c' }, // Green focus effect
            '& .MuiInputLabel-root.Mui-focused': { color: '#4caf50' }, // Green label on focus
          }}
        />

        {/* Address */}
        <TextField
          fullWidth
          label="Address"
          name="address"
          value={formData.address}
          onChange={handleChange}
          variant="standard"
          sx={{
            mb: 2,
            '& .MuiInput-underline:before': { borderBottomColor: '#388e3c' }, // Default black underline
            '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: '#4caf50' }, // Green hover effect
            '& .MuiInput-underline:after': { borderBottomColor: '#388e3c' }, // Green focus effect
            '& .MuiInputLabel-root.Mui-focused': { color: '#4caf50' }, // Green label on focus
          }}
        />

        {/* Radio Buttons */}
        <RadioGroup
          name="radioOption"
          value={formData.radioOption}
          onChange={handleChange}
          sx={{
            mb: 3,
            flexDirection: isMobile ? 'column' : 'row',
          }}
        >
          <FormControlLabel value="Arial Surveying" control={<Radio />} label="Arial Surveying" />
          <FormControlLabel value="Crop Spraying" control={<Radio />} label="Crop Spraying" sx={{marginLeft: isMobile ?"":"58px"}} />
          <FormControlLabel value="Crop Monitoring" control={<Radio />} label="Crop Monitoring" />
          <FormControlLabel value="Drone Delivery" control={<Radio />} label="Drone Delivery" sx={{marginLeft: isMobile ?"":"49px"}}/>
        </RadioGroup>
      </Box>

      {/* Dialog Actions */}
      <DialogActions sx={{ backgroundColor: '#FFFFFF'}}>
        <Button
          onClick={handleDialogClose}
          variant="text"
          sx={{
            color: '#333',
            fontWeight: 600,
            px: 3,
            '&:hover': { backgroundColor: '#f2f2f2' },
            mt:2,
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          sx={{
            backgroundColor: '#388e3c',
            color: 'white',
            borderRadius: 30,
            px: 3,
            '&:hover': { backgroundColor: '#4caf50' },
            mt:2,
          }}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
</Box>



      {/* Services We Offer Section */}
      <Box sx={{ padding: '30px 10%' }}>
  <Grid container spacing={2} alignItems="center" sx={{ flexDirection: { xs: 'column', md: 'row' } }}>
    {/* Left Side - Green Heading */}
    <Grid item xs={12} md={4} sx={{ paddingLeft: { xs: '0', md: '30%' }, textAlign: { xs: 'center', md: 'left' } }}>
      <Typography
        variant="h4"
        sx={{
          color: '#24ac00',
          fontWeight: 'bold',
          borderBottom: '2px solid green',
          paddingBottom: '5px',
        }}
      >
        Services We Offer
      </Typography>
    </Grid>

    {/* Right Side - Paragraph */}
    <Grid item xs={12} md={8} sx={{ paddingLeft: { xs: '0', md: '30%' }, textAlign: { xs: 'center', md: 'left' } }}>
      <Typography variant="body1" sx={{ fontSize: '1rem', marginTop: 2 }}>
        We provide top-tier drone services ranging from aerial photography and surveying to
        on-demand hiring of skilled drone pilots and technicians. Whether you're in need of
        aerial mapping, inspections, or drone maintenance, we have you covered with our expert
        professionals.
      </Typography>
    </Grid>
  </Grid>

  {/* Cards Section */}
  <Grid container spacing={2} sx={{ marginTop: 4, justifyContent: 'center', flexDirection: { xs: 'column', sm: 'row' } }}>
    {/* Card 1 */}
    <Grid item xs={12} sm={4} sx={{ paddingLeft: { xs: '0', sm: '10%' }, marginBottom: { xs: '20px', sm: '0' } }}>
      <Card sx={{ height: '400px', width: '100%', position: 'relative' }}>
        <CardMedia
          component="img"
          height="100%" // Set image to take the full height
          image={image3} // Replace with your image source
          alt="Surveying & Mapping"
          sx={{ objectFit: 'cover' }} // Ensure image covers the full card without distortion
        />
        {/* Black Tint Overlay */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)', // Black tint with transparency
          }}
        />
        <CardContent
          sx={{
            position: 'absolute',
            bottom: '10px', // Position from the bottom
            left: '10px', // Position from the left
            color: 'white',
            textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)', // Optional text shadow for better readability
          }}
        >
          <Typography variant="h5">
            Surveying & <br />Mapping
          </Typography>
        </CardContent>
      </Card>
    </Grid>

    {/* Card 2 */}
    <Grid item xs={12} sm={4} sx={{ paddingLeft: { xs: '0', sm: '5%' }, marginBottom: { xs: '20px', sm: '0' } }}>
      <Card sx={{ height: '400px', width: '100%', position: 'relative' }}>
        <CardMedia
          component="img"
          height="100%" // Set image to take the full height
          image={image1} // Replace with your image source
          alt="Photography & Videography"
          sx={{ objectFit: 'cover' }} // Ensure image covers the full card without distortion
        />
        {/* Black Tint Overlay */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)', // Black tint with transparency
          }}
        />
        <CardContent
          sx={{
            position: 'absolute',
            bottom: '10px', // Position from the bottom
            left: '10px', // Position from the left
            color: 'white',
            textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)', // Optional text shadow for better readability
          }}
        >
          <Typography variant="h5">Photography & Videography</Typography>
        </CardContent>
      </Card>
    </Grid>

    {/* Card 3 */}
    <Grid item xs={12} sm={4} sx={{ paddingLeft: { xs: '0', sm: '5%' } }}>
      <Card sx={{ height: '400px', width: '100%', position: 'relative' }}>
        <CardMedia
          component="img"
          height="100%" // Set image to take the full height
          image={image5} // Replace with your image source
          alt="Inspection & Surveillance"
          sx={{ objectFit: 'cover' }} // Ensure image covers the full card without distortion
        />
        {/* Black Tint Overlay */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)', // Black tint with transparency
          }}
        />
        <CardContent
          sx={{
            position: 'absolute',
            bottom: '10px', // Position from the bottom
            left: '10px', // Position from the left
            color: 'white',
            textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)', // Optional text shadow for better readability
          }}
        >
          <Typography variant="h5">Inspection & Surveillance</Typography>
        </CardContent>
      </Card>
    </Grid>
  </Grid>
</Box>


<Box>
  {/* Video Section */}
  <Box sx={{ position: 'relative', width: '100%', height: { xs: '50vh', md: '60vh' } }}>
  <video
    src={imgss} // Replace with your video URL
    autoPlay
    loop
    muted
    style={{
      width: '100%',
      height: '100%',
      objectFit: 'cover',pointerEvents: 'none', // Disable interaction with the video
    }}
    playsInline // Ensures video plays inline on iOS
    controls={false} // Disable default controls
    onError={(e) => console.error("Video failed to load", e)} // Debugging
  />
  
  {/* Black Tint Overlay */}
  <Box
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)', // Black tint with opacity (adjust 0.5 for intensity)
    }}
  />
  
  {/* Overlay Content */}
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      textAlign: 'center',
      color: 'white',
      fontWeight: 'bold',
    }}
  >
    <Typography variant="h4">Aerial Operations Made Easy</Typography>
  </Box>
</Box>


  {/* Card with Icons and Text */}
  <Card sx={{
  height: 'auto', // Let it adjust according to content
  position: 'relative',
  top: '-30px',
  zIndex: 1,
  width: { xs: '90%', md: '70%' },  // Adjust card width to be 90% on mobile
  margin: '0 auto',
  
  paddingBottom: { xs: '20px', sm: '30px' }, // Adjust bottom padding to reduce overall height
  boxSizing: 'border-box', // Ensure box-sizing includes padding and border
}}>
  <CardContent
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: { xs: '10px', sm: '0 20px' }, // Adjust padding for mobile to reduce height
      marginTop: { xs: '10px', sm: '15px' }, // Adjust margin for mobile
    }}
  >
    <Grid container spacing={4} justifyContent="center" sx={{ flexDirection: { xs: 'column', sm: 'row' } }}>
      {/* Icon and Text Section 1 */}
      <Grid item xs={12} sm={4} sx={{ display: 'flex', alignItems: 'center', marginBottom: { xs: '15px', sm: '0' } }}>
        <img src={logo} alt="Logo" style={{ width: 40, marginRight: 20 }} />
        <Box>
          <Typography variant="h6">Spray Acres/Day</Typography>
          <Typography variant="body2" sx={{ marginTop: 1 }}>
            Productivity
          </Typography>
        </Box>
        <Divider orientation="vertical" flexItem sx={{ marginLeft: 2, marginRight: 2, display: { xs: 'none', sm: 'block' } }} />
      </Grid>

      {/* Icon and Text Section 2 */}
      <Grid item xs={12} sm={4} sx={{ display: 'flex', alignItems: 'center', marginBottom: { xs: '15px', sm: '0' } }}>
        <img src={logo1} alt="Logo" style={{ width: 40, marginRight: 20 }} />
        <Box>
          <Typography variant="h6">5 Mins</Typography>
          <Typography variant="body2" sx={{ marginTop: 1 }}>
            For an Acer Only
          </Typography>
        </Box>
        <Divider orientation="vertical" flexItem sx={{ marginLeft: 2, marginRight: 2, display: { xs: 'none', sm: 'block' } }} />
      </Grid>

      {/* Icon and Text Section 3 */}
      <Grid item xs={12} sm={4} sx={{ display: 'flex', alignItems: 'center' }}>
        <img src={logo2} alt="Logo" style={{ width: 40, marginRight: 20 }} />
        <Box>
          <Typography variant="h6">No Human Exposure</Typography>
          <Typography variant="body2" sx={{ marginTop: 1 }}>
            Find Your Nearest Store
          </Typography>
        </Box>
      </Grid>
    </Grid>
  </CardContent>
</Card>


</Box>



  <Box sx={{ marginTop: 2, padding: { xs: '20px', sm: '30px 70px' } }}>
  {/* On Demand Hiring Section */}
  <Grid container spacing={4} sx={{ alignItems: 'flex-start' }}>
    {/* Heading with Green Color */}
    <Grid item xs={12} sm={6}>
      <Typography variant="h2" sx={{ color: '#24ac00', fontWeight: 'bold' }}>
        On Demand<br></br> Hiring
      </Typography>
      {/* Paragraph under the heading */}
      <Typography variant="body1" sx={{ marginTop: 1, fontWeight: 'bold', fontSize: { xs: '16px', sm: '20px' } }}>
        Hire DGCA-certified drone pilots for specific projects
      </Typography>

      {/* Second Image Card directly below the paragraph */}
      <Box sx={{ marginTop: '20px' }}> {/* 10px gap added here */}
        <Grid container>
          <Grid item xs={12} sm={12}>
            <Card sx={{ height: '100%', display: 'flex' }}>
              <CardMedia
                component="img"
                height="100%" // Ensure image takes the full height of the card
                image={image} // Replace with your image source
                alt="Inspection & Surveillance"
                sx={{ objectFit: 'cover' }} 
              />
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Grid>

    {/* Card with Image on the right side */}
    <Grid item xs={12} sm={6}>
      <Card sx={{ height: '100%', display: 'flex' }}>
        <CardMedia
          component="img"
          height="100%" // Ensure image takes the full height of the card
          image={image4} // Replace with your image source
          alt="Inspection & Surveillance"
          sx={{ objectFit: 'cover' }} 
        />
      </Card>
      <Typography variant="body1" sx={{ marginTop: 1, fontSize: { xs: '16px', sm: '20px' }, fontWeight: 'bold' }}>
        Technicians available for equipment setup, maintenance, and field operations.
      </Typography>
    </Grid>
  </Grid>
</Box>



<Box sx={{ marginTop: 4, padding: { xs: '20px', sm: '30px 70px' } }}>
  {/* Why Choose Us Section */}
  <Typography variant="h2" sx={{ color: '#24ac00', textAlign: 'center', fontWeight: 'bold', fontSize: { xs: '24px', sm: '32px' } }}>
    Why Choose Us?
  </Typography>

  {/* 3 Cards in a Row */}
  <Grid container spacing={4} sx={{ marginTop: 4 }} justifyContent="center">
    {/* Card 1 */}
    <Grid item xs={12} sm={4}>
      <Card sx={{
        height: '100%', // Make the card take up full available height
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '10px',
        backgroundColor: 'white',
        minHeight: '350px', // Set a minimum height to ensure consistency
      }}>
        <CardContent sx={{ textAlign: 'center' }}>
          {/* Card Heading */}
          <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'black', fontSize: { xs: '18px', sm: '24px' } }}>
            Expert Network
          </Typography>
          
          {/* Paragraph */}
          <Typography variant="body1" sx={{ fontWeight: 'bold', color: '#24ac00', marginTop: 1, fontSize: { xs: '14px', sm: '12px' } }}>
            Access to trained and certified professionals.
          </Typography>
        </CardContent>
        {/* Image - Full width */}
        <CardMedia
          component="img"
          height="250"
          image={image8}
          alt="Expert Network"
          sx={{ objectFit: 'cover', borderRadius: '0 0 10px 10px' }} 
        />
      </Card>
    </Grid>

    {/* Card 2 */}
    <Grid item xs={12} sm={4}>
      <Card sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '10px',
        backgroundColor: 'white',
        minHeight: '350px', // Set a minimum height to ensure consistency
      }}>
        <CardContent sx={{ textAlign: 'center' }}>
          {/* Card Heading */}
          <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'black', fontSize: { xs: '18px', sm: '24px' } }}>
            Flexibility
          </Typography>
      
          {/* Paragraph */}
          <Typography variant="body1" sx={{ fontWeight: 'bold', color: '#24ac00', marginTop: 1, fontSize: { xs: '14px', sm: '12px' } }}>
            Hire on a daily, project, or long-term basis
          </Typography>
        </CardContent>
        {/* Image - Full width */}
        <CardMedia
          component="img"
          height="250"
          image={image7}
          alt="Flexibility"
          sx={{ objectFit: 'cover', width: '100%', borderRadius: '0 0 10px 10px' }} 
        />
      </Card>
    </Grid>

    {/* Card 3 */}
    <Grid item xs={12} sm={4}>
      <Card sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '10px',
        backgroundColor: 'white',
        minHeight: '350px', // Set a minimum height to ensure consistency
      }}>
        <CardContent sx={{ textAlign: 'center' }}>
          {/* Card Heading */}
          <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'black', fontSize: { xs: '18px', sm: '24px' } }}>
            Quality Assurance
          </Typography>
          
          {/* Paragraph */}
          <Typography variant="body1" sx={{ fontWeight: 'bold', color: '#24ac00', marginTop: 1, fontSize: { xs: '14px', sm: '12px' } }}>
            Top-notch services tailored to your needs
          </Typography>
        </CardContent>
        {/* Image - Full width */}
        <CardMedia
          component="img"
          height="250"
          image={image6}
          alt="Quality Assurance"
          sx={{ objectFit: 'cover', borderRadius: '0 0 10px 10px' }} 
        />
      </Card>
    </Grid>
  </Grid>
</Box>


<Box sx={{ padding: { xs: '20px', md: '40px' } }}>
  {/* Main Card */}
  <Card sx={{ borderRadius: '8px', boxShadow: 3, backgroundColor: '#f8f7f0' }}>
    <CardContent>
      <Grid container spacing={4} alignItems="center">
        {/* Left Side - Heading and Paragraph */}
        <Grid item xs={12} md={6}>
          <Typography
            variant="h5"
            sx={{
              color: '#24ac00',
              fontWeight: 'bold',
              marginTop: { xs: '0', md: '-80px' }, // Adjust margin for mobile view
              fontSize: { xs: '24px', sm: '28px', md: '32px' }, // Responsive font size
              textAlign: { xs: 'center', md: 'left' }, // Center the text on mobile
            }}
          >
            How It Works?
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: 'text.secondary',
              marginTop: '8px', // Add margin-top for spacing
              fontSize: { xs: '14px', sm: '16px', md: '18px' }, // Responsive font size
              textAlign: { xs: 'center', md: 'left' }, // Center the text on mobile
            }}
          >
            Book Drone-as-a-Service in three simple steps:
          </Typography>
        </Grid>

        {/* Right Side - Three Cards with Connecting Lines */}
        <Grid item xs={12} md={6}>
          <Box sx={{ position: 'relative' }}>
            {/* Vertical Line Between Cards */}
            <Box
              sx={{
                position: 'absolute',
                top: '40px',
                left: '30px',
                width: '2px',
                backgroundColor: 'green',
                zIndex: 2,
                height: '24%',
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                top: '100px',
                left: '30px',
                width: '2px',
                backgroundColor: 'green',
                zIndex: 2,
                height: '24%',
              }}
            />

            {/* Card 1 */}
            <Card
              sx={{
                position: 'relative',
                zIndex: 1,
                marginBottom: '12px',
                borderRadius: '8px',
                boxShadow: 0,
                padding: '0px',
                height: '50px',
              }}
            >
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Box
                    sx={{
                      width: '30px',
                      height: '30px',
                      borderRadius: '50%',
                      backgroundColor: 'green',
                      color: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontWeight: 'bold',
                      fontSize: '14px',
                      marginRight: '12px',
                    }}
                  >
                    1
                  </Box>
                  <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '14px' }}>
                    Choose Your Service or Professional
                  </Typography>
                </Box>
              </CardContent>
            </Card>

            {/* Card 2 */}
            <Card
              sx={{
                position: 'relative',
                zIndex: 1,
                marginBottom: '12px',
                borderRadius: '8px',
                boxShadow: 0,
                padding: '0px',
                height: '50px',
              }}
            >
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Box
                    sx={{
                      width: '30px',
                      height: '30px',
                      borderRadius: '50%',
                      backgroundColor: 'green',
                      color: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontWeight: 'bold',
                      fontSize: '14px',
                      marginRight: '12px',
                    }}
                  >
                    2
                  </Box>
                  <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '14px' }}>
                    Submit Your Requirements
                  </Typography>
                </Box>
              </CardContent>
            </Card>

            {/* Card 3 */}
            <Card
              sx={{
                position: 'relative',
                zIndex: 1,
                marginBottom: '12px',
                borderRadius: '8px',
                boxShadow: 0,
                padding: '0px',
                height: '50px',
              }}
            >
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Box
                    sx={{
                      width: '30px',
                      height: '30px',
                      borderRadius: '50%',
                      backgroundColor: 'green',
                      color: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontWeight: 'bold',
                      fontSize: '14px',
                      marginRight: '12px',
                    }}
                  >
                    3
                  </Box>
                  <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '14px' }}>
                    Confirm Booking and Get Started
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Box>
        </Grid>
      </Grid>

      {/* Image Below the Cards */}
      <Box sx={{ marginTop: '0px', display: 'flex', justifyContent: 'center', position: 'relative' }}>
        {/* First image */}
        <img
          src={droneImage5}  // Replace with the actual URL of your image
          alt="How it works illustration"
          style={{
            width: '130%',
            height: '200px',
            maxWidth: 'none',
            borderRadius: '8px',
          }}
        />
        {/* Second image on top of the first */}
        <img
          src={drone}  // Replace with the actual URL of the second image
          alt="Overlay image"
          style={{
            position: 'absolute',
            top: '0px',
            left: '15%',
            transform: 'translateX(-50%)',
            width: '50px',
            height: '50px',
            borderRadius: '8px',
          }}
        />
      </Box>
    </CardContent>
  </Card>
</Box>


                    

    </div>
  );
};

export default DroneRepair;
